import { memo } from 'react';
import { themeCssVar as theme } from '@tinderapp/ui-react';

import SvgIcon from './lib/SvgIcon';

type Props = React.ComponentProps<typeof SvgIcon> & {
  fill?: string;
};

const TinderUIcon = (props: Props) => {
  const { fill = theme.gradientFill.backgroundBrandGradient, ...restProps } = props;

  return (
    <SvgIcon {...restProps}>
      <g fill={fill} fillRule="evenodd">
        <path d="M18.99 3.9l1.7 1.7-.29 2h-1.04l-.14.94-1.35 9.64-2.58 2.56H8.9l-1.48-1.47H5.86l2.58 2.57h7.31l3.16-3.15 1.4-10h1.05l.5-3.5h-.02l-2.67-2.65z" />
        <path d="M18 3.03H11.2l-.47 3.36h1l-1.09 7.64-.4.34H7.51l-.4-.45L8.18 6.4h1l.47-3.36h-6.8l-.47 3.36h1.01l-1.38 9.7L5 19.02h7.09L15.16 16l1.36-9.61h1.01l.48-3.36z" />
      </g>
    </SvgIcon>
  );
};

TinderUIcon.normalized = true;

export default memo(TinderUIcon);
